
jQuery(function($) {


    /* Attention // uniquement si mobile ou tablette ! PODOM */
    $('#primary-menu li.menu-item-has-children > a').click(function(e) {
      $(this).parent().toggleClass('focus');
      e.preventDefault();
      // charge transition
  });

  var hadraHeader = document.querySelector("header.site-header");

// construct an instance of Headroom, passing the element

function isNavVisible(hadraHeader) {
  return (hadraHeader.classList.contains('open-s-menu') ? true : false );
}




var options = {
    offset : 60,

    // scroll tolerance in px before state changes
 //   tolerance : 0,
    // or you can specify tolerance individually for up/down scroll
    tolerance : {
        up : 5,
        down : 0
    },

  onUnpin: function() {
    if ( isNavVisible(hadraHeader) ) {
      this.elem.classList.remove(this.classes.unpinned);
      this.elem.classList.add(this.classes.pinned);
    }
    else {
      this.elem.classList.add(this.classes.unpinned);
      this.elem.classList.remove(this.classes.pinned);
    }
  }
};

var headroom  = new Headroom(hadraHeader,options);

// initialise
headroom.init();

  
/* PODOM MINIMIFY THIS */
     /* Accessibility / Light / Dark et Contraste thème */
 
    function calculateSettingAsThemeString({ localStorageTheme}) {

      if (localStorageTheme !== null) {
        return localStorageTheme;
      }

      return "standard";
    }


    /**
    * Utility function to update the theme setting on the html tag
    */
    function updateThemeOnHtmlEl({ theme }) {
      document.querySelector("html").setAttribute("data-theme", theme);
        buttonsChangeTheme.forEach(item => {
        item.classList.remove("selected");
      });
        document.querySelector('[data-theme-toggle][data-theme="'+theme+'"]').classList.add("selected");
    }

    /**
    * On page load:
    */


    /**
    * 1. Grab what we need from the DOM and system settings on page load
    */
    const buttonsChangeTheme = document.querySelectorAll("[data-theme-toggle]");
    const localStorageTheme = localStorage.getItem("theme");

    /**
    * 2. Work out the current site settings
    */
    let currentThemeSetting = calculateSettingAsThemeString({ localStorageTheme });

    /**
    * 3. Update the theme setting and button text accoridng to current settings
    */
    updateThemeOnHtmlEl({ theme: currentThemeSetting });


    /**
    * 4. Add an event listener to toggle the theme
    */
    buttonsChangeTheme.forEach(item => {
      item.addEventListener('click', event => {
        //handle click
        const newTheme = item.dataset.theme;
        localStorage.setItem("theme", newTheme);
        updateThemeOnHtmlEl({ theme: newTheme });
        currentThemeSetting = newTheme;
    
      });
    });


/*****************************************************/
  /************** CHANGE SIZE TYPOGRAPHIE ****/
/*****************************************************/

function calculateSettingSize({ localStorageSize}) {
    if (localStorageSize !== null) {
      return localStorageSize;
    }
    return "100";
}


 function updateSizeOnHtmlEl({ size }) {
   // document.querySelector("html").setAttribute("data-size", size+'%');
   document.querySelector("html").style.fontSize = size+'%';


   if(parseInt(size) > 125){
    document.querySelector('[data-size="more"]').disabled = true;
   }else{
      document.querySelector('[data-size="more"]').disabled = false;
   }

   if(parseInt(size) < 75){
    document.querySelector('[data-size="less"]').disabled = true;
   }else{
      document.querySelector('[data-size="less"]').disabled = false;
   }

    if(parseInt(size) == 100){
    document.querySelector('[data-size="standard"]').disabled = true;
   }else{
      document.querySelector('[data-size="standard"]').disabled = false;
   }

   


    //   buttonsChangeTheme.forEach(item => {
    //     item.classList.remove("selected");
    // });
    //   document.querySelector('[data-theme-toggle][data-theme="'+theme+'"]').classList.add("selected");
 }

const buttonsChangeSize = document.querySelectorAll("[data-change-size]");
const localStorageSize = localStorage.getItem("size");

let currentThemeSize = calculateSettingSize({ localStorageSize});
updateSizeOnHtmlEl({size:currentThemeSize});

buttonsChangeSize.forEach(item => {
    item.addEventListener('click', event => {
      //handle click
      const SizeDirection = item.dataset.size;
      if(SizeDirection == 'standard') newSize = 100; 
      else if(SizeDirection == 'less') newSize = parseInt(currentThemeSize)-10; else newSize = parseInt(currentThemeSize)+10;
      localStorage.setItem("size", newSize);
      updateSizeOnHtmlEl({ size: newSize });
      currentThemeSize = newSize;
    });
});





/* ******************************************************** */
/* ******** LIGHTBOX - IFRAME HOME PAGE YOUTUBE   ********** */
/* ******************************************************** */
     

      if($(".open-popup-link"). length){
    
        $('document').ready(function(){
          $('.open-popup-link').magnificPopup({
            type:'inline',
            midClick: true,
            mainClass: 'mfp-fade',
            callbacks: {
            open: function() {
               videojs('showreel_lightbox').play();
            
                var mainVideo = $('#video_home');
                mainVideo[0].pause();

            },
            close: function() {
              videojs('showreel_lightbox').pause();
               var mainVideo = $('#video_home');
              mainVideo[0].play();
            }
            // e.t.c.
          }

          });
       
        });
      }




// /***********  ******************** ********/ 
// /*********** SWIPER HOME POST LINK ********/ 
// /***********  ******************** ********/ 
  var swiper_module_a = new Swiper('.swiper-container-mA', {

      // If we need pagination
        spaceBetween: 16, // try '5%' if you want
        centeredSlides: true,
        slidesPerView: 1.35,
        loop: true,
        autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },

       navigation: {
        nextEl: '.Sactus-L .swiper-button-next',
        prevEl: '.Sactus-L .swiper-button-prev'
    },

    pagination: {
         el: '.swiper-bullet-pagination',
         clickable: true
    },

      breakpoints: {
        2000: { // a partir de 769

          spaceBetween: 20,
          slidesPerView: 4.5,
          loop: true,
          centeredSlides: false,
        },
        1440: { // a partir de 769

          spaceBetween: 20,
          slidesPerView: 3.5,
          loop: true,
          centeredSlides: false,
        },
        1023: { // a partir de 769
          spaceBetween: 20,
          slidesPerView: 2.5,
          loop: true,
          centeredSlides: false,
        },
        600: { // a partir de 769
          spaceBetween: 20,
          slidesPerView: 2.5,
          loop: true,
          centeredSlides: false,
        }
      },
  }); 



  // /***********  ******************** ********/ 
// /*********** SWIPER CONTAINER CAROUSEL CMS ********/ 
// /***********  ******************** ********/ 
  var swiper_container_mF_carrousel = new Swiper('.swiper-container-mF_carrousel', {

      // If we need pagination
        spaceBetween: 10, // try '5%' if you want
        centeredSlides: false,
        slidesPerView: 1.15,
        loop: true,
          autoplay: {
          delay: 6000,
          disableOnInteraction: false
        },

      navigation: {
        nextEl: '.mF_cImg-content-nav .swiper-button-next',
        prevEl: '.mF_cImg-content-nav .swiper-button-prev'
    },

    // pagination: {
    //      el: '.swiper-bullet-pagination',
    //      clickable: true
    // },

      breakpoints: {
        1340: { // a partir de 769
          spaceBetween: 162,
          slidesPerView:'auto',
          loop: true,
        },
        1025: { // a partir de 769
          spaceBetween: 20,
          slidesPerView: 1.5,
          loop: true,
        },
        600: { // a partir de 769
          spaceBetween: 20,
          slidesPerView: 1.2,
          loop: true,
        }
      },
  }); 

// /***********  ******************** ********/ 
  // /***********  CHANGE EXPLORE ********/ 
// /***********  ******************** ********/ 

  // precache all images so they will load on demand
var imgs = []; 
var url_night = $('.ExploreHome').data('img-night');
var url_day = $('.ExploreHome').data('img-day');
var url_new_img = '';
$('span.switch_explore').each(function() {
    var img = new Image();
    if($(this).hasClass('dark')) img.src = url_night;
    else img.src = url_day;
    imgs.push(img);
}).click(function () {
    var oldImg = $(".explore_container_js img");
    
    var img = new Image();
    img.src = $(this).data('url');
    var newImg = $(img).hide();
    $(".explore_container_js").append(img);
    
    oldImg.stop(true).fadeOut(500, function() {
        $(this).remove();
    });
    newImg.fadeIn(500);
    return false;
});
  
    $('#ch_change_ambiance').change(function() {
        if(this.checked) {
           change_ambiance('day');
        }else{
           change_ambiance('night');
        }
          
    });

    function change_ambiance(day_or_night){
      console.log(day_or_night);
      if(day_or_night == "night"){
        url_new_img = url_night;
           
      }else{
        url_new_img = url_day;
      }

       var oldImg = $(".explore_container_js img");
       var img = new Image();
       img.src = url_new_img;
       var newImg = $(img).hide();

       $(".explore_container_js").append(img);
         $('.ExploreHome').removeClass('night day').addClass(day_or_night);
        oldImg.stop(true).fadeOut(500, function() {
          $(this).remove();

      });
      newImg.fadeIn(500);

    }


    // /***********  ******************** ********/ 
// /*********** SWIPER FOOTER TESTIMONY ********/ 
// /***********  ******************** ********/ 
  var swiper_container_mTestimony = new Swiper('.swiper-container-mTestimony', {

      // If we need pagination
        spaceBetween: 16, // try '5%' if you want
        centeredSlides: true,
        slidesPerView: 1,
        loop: true,
        autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },

       navigation: {
        nextEl: '.center_short_nav .swiper-button-next',
        prevEl: '.center_short_nav .swiper-button-prev'
    },

  }); 


     // /***********  ******************** ********/ 
// /*********** SWIPER PARTENAIRE / LISTE DE LOGO ********/ 
// /***********  ******************** ********/ 
  var swiper_container_mPartnerFoot = new Swiper('.swiper-container-mPartnerFoot', {

      // If we need pagination
        spaceBetween: 16, // try '5%' if you want
        centeredSlides: true,
        slidesPerView: 4.2,
        loop: true,
        autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },

        breakpoints: {
        1025: { // a partir de 769
          spaceBetween: 15,
          centeredSlides: false,
          slidesPerView: 12.2,
          loop: true,
        },
        769: { // a partir de 769
          spaceBetween: 15,
          centeredSlides: true,
          slidesPerView: 9.2,
          loop: true,
        },
         500: { // a partir de 769
          spaceBetween: 15,
          centeredSlides: true,
          slidesPerView: 7.2,
          loop: true,
        },
        420: { // a partir de 769
          spaceBetween: 15,
          centeredSlides: true,
          slidesPerView: 5.2,
          loop: true,
        }
      },

  }); 

  var copy_header_m = $('.BigMenuR2, .BigMenuR3, .BigMenuR5').clone();
  $('.header-mobile-footer').append(copy_header_m);


  $( ".STicket" ).each(function( index ) {
    var elts = $( this ).find('.front .STicket-Inner').html();
    $( this ).find('.back .STicket-Inner').append(elts);
   
  });





   ////////////////
    //// GLOBAL accordion 
   ///////////////
   $('.accordion-section-content:not(.first)').hide();
   $('.acc-item.first').addClass('active');
    //$('#content_s_1').parent().find('h2 a').addClass('active');

   //$('.accordion-section-content').hide();
    // accordion SECTION 
    function close_accordion_section() {
        $('.accordion-page .accordion-section-title').removeClass('active');
        $('.accordion-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('aria-controls');
      
        var parentActiveAcc = $(this).parent().parent().parent().attr('data-accordion-id');

         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).slideUp(300);
         $(parentActiveAcc + ' .acc-item.active .accordion-section-title:not([aria-controls="'+currentAttrValue+'"])').attr('aria-expanded', 'false');
         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $(this).attr('aria-expanded', 'false');
            $('.accordion-page ' + '#'+currentAttrValue).slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            $(this).attr('aria-expanded', 'true');
            // Open up the hidden content panel
            $('.accordion-page ' + '#'+currentAttrValue).slideDown(300).addClass('open');
            if($('#'+currentAttrValue+'-number').length){
              let to_number = $('#'+currentAttrValue+'-number').attr('data-number');
              let demo = new countUp.CountUp(currentAttrValue+'-number', to_number, options_count);
              demo.start();
            } 
            
        }
 
        e.preventDefault();
    });
    // FIN accordion //
    ////////////////////


        /* **************************************************  */
        /* GALERY DANS LES PAGES */
        /* **************************************************  */

         $(".lightgallery, .js-lightgallery").lightGallery({
              subHtmlSelectorRelative: true,
              selector:'a',
        }); 


        $('.to_nicedropdown-js').niceSelect();



    /*********************************/
      /** PAGE PROG / FILTER / LIGHTBOX / BUTTON .. **/
    /*********************************/


    /*********************************/
      /** MASONRY POUR LES ARTISTES DANS LA PAGE DE PROGRAMMATION DE LA SAISON COURANTE **/
    /*********************************/
      $('#recherche_prog button').on('click',function(){
           return false;
      });


    var coll = document.getElementsByClassName("collapsible");
    var i;

    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", function() {
        this.classList.toggle("active");
        this.parentNode.classList.toggle("active_filters");
        // if(this.parentNode.classList.contains('active_filters')){

        // }
        var content = this.nextElementSibling;
        if (content.style.maxHeight){
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    }

         /* Masonry Project archive */  
    var $container_project_masonry = $('.prog-resume-listcontainer');
    var grid_isotope;
    var class_filter_init = '*';
    var string_number_filter = document.getElementById('number-filter');
   // if(string_value.type_filter_rea != '*') class_filter_init = '.'+string_value.type_filter_rea;
    $container_project_masonry.imagesLoaded(function () {
        grid_isotope = $container_project_masonry.isotope({
            itemSelector: '.grid-item',
            percentPosition: true,
            filter:class_filter_init,
            stamp: '.stamp',
            masonry: {
                columnWidth: '.gridpost-sizer',
                gutter: '.gridpost-gutter-sizer',
            } 
        });
    });

   grid_isotope = $container_project_masonry.isotope({
            itemSelector: '.grid-item',
            percentPosition: true,
            filter:class_filter_init,
            stamp: '.stamp',
            masonry: {
                columnWidth: '.gridpost-sizer',
                gutter: '.gridpost-gutter-sizer',
            } 
    });


     // https://codepen.io/desandro/pen/DeGjdQ
    var filters = {};
      // do stuff when checkbox change
    $(".blockFilterAction input[type='checkbox']").on( 'change', function( jQEvent ){
      var $checkbox = $( jQEvent.target );
      manageCheckbox( $checkbox );

      var comboFilter = getComboFilter( filters );
      //console.log(comboFilter);
      grid_isotope.isotope({ filter: comboFilter });
      
      var filteredItems = grid_isotope.isotope('getFilteredItemElements');
      $('.resume-prog').removeClass('filter_active');
      filteredItems.forEach(elm => elm.classList.add('filter_active')); 

      string_number_filter.textContent = "("+grid_isotope.data('isotope').filteredItems.length+")";
      var elm = string_number_filter;
      var newone = elm.cloneNode(true);
      string_number_filter = newone;
      elm.parentNode.replaceChild(newone, elm);
    });

     function getComboFilter( filters ) {
    var i = 0;
    var comboFilters = [];
    var message = [];

    for ( var prop in filters ) {
      message.push( filters[ prop ].join(' ') );
      var filterGroup = filters[ prop ];
      // skip to next filter group if it doesn't have any values
      if ( !filterGroup.length ) {
        continue;
      }
      if ( i === 0 ) {
        // copy to new array
        comboFilters = filterGroup.slice(0);
      } else {
        var filterSelectors = [];
        // copy to fresh array
        var groupCombo = comboFilters.slice(0); // [ A, B ]
        // merge filter Groups
        for (var k=0, len3 = filterGroup.length; k < len3; k++) {
          for (var j=0, len2 = groupCombo.length; j < len2; j++) {
            filterSelectors.push( groupCombo[j] + filterGroup[k] ); // [ 1, 2 ]
          }

        }
        // apply filter selectors to combo filters for next group
        comboFilters = filterSelectors;
      }
      i++;
    }

    var comboFilter = comboFilters.join(', ');
    return comboFilter;
  }

    function manageCheckbox( $checkbox ) {
      var checkbox = $checkbox[0];

      var group = $checkbox.parents('.option-set').attr('data-group');
      // create array for filter group, if not there yet
      var filterGroup = filters[ group ];
      if ( !filterGroup ) {
        filterGroup = filters[ group ] = [];
      }

      var isAll = $checkbox.hasClass('all');
      // reset filter group if the all box was checked
      if ( isAll ) {
        delete filters[ group ];
       
        if ( !checkbox.checked ) {
          checkbox.checked = 'checked';
        }
      }
      // index of
      var index = $.inArray('.'+checkbox.value, filterGroup );

      if ( checkbox.checked ) {
        var selector = isAll ? 'input.other' : 'input.all';
        $checkbox.parents('.option-set').find( selector ).removeAttr('checked');


        if ( !isAll && index === -1 ) {
          // add filter to group
          filters[ group ].push('.'+checkbox.value );
        }

      } else if ( !isAll ) {
        // remove filter from group
        filters[ group ].splice( index, 1 );
        // if unchecked the last box, check the all
          if ($checkbox.parents('.option-set').find('input:checked').length == 0) {
           $checkbox.parents('.option-set').find('input.all').prop('checked', true);
        }
      }

  }

    $(document).on("click", ".js-open-info", function(e) {
            
             var all = $.featherlight.opened();
                var first = all[0];
                if(first){
                  first.close();
                }

           $.featherlight('<div class="loader_js_container"><div class="loader_js"></div></div>',{
              contentFilters: ["html"],
              closeIcon: '<i class="icon-close"></i>', 
               persist : 'shared',
              afterContent : function(a){
             

                // var all = $.featherlight.opened();
                // var first = all[0];
                // if(first){
                //   first.close();
                // }
                 var $ID_ARTISTE = parseInt($(e.currentTarget).attr('data-id-artiste'));


               
                $.ajax({
                    type: 'POST',
                    url: object_var.ajaxurl,
                    data: { 
                        'action': 'call_artiste',
                        'id_artiste': $ID_ARTISTE
                    },
                    success: function(data){
                      $('.loader_js_container').hide(500, function(){
                        $('.featherlight-content').addClass('charge_off').append(data).hide().slideToggle(500);
                       // add_lightbox_prog_single('.featherlight');
                      });
                       
                        var next_elt = $('.prog-resume-listcontainer .js-open-info[data-id-artiste="'+$ID_ARTISTE+'"]').nextAll('.filter_active');
                        var prev_elt = $('.prog-resume-listcontainer .js-open-info[data-id-artiste="'+$ID_ARTISTE+'"]').prevAll('.filter_active');
                        var to_add = '';

                     
                        if(next_elt.length){
                          to_add += '<a href="'+next_elt.attr('href')+'" class="lb_next js-open-info lb_button" data-id-artiste="'+next_elt.attr('data-id-artiste')+'"><i class="icon-next_round"></i></a>';
                        }
                        if(prev_elt.length){
                          to_add += '<a href="'+prev_elt.attr('href')+'" class="lb_prev js-open-info lb_button" data-id-artiste="'+prev_elt.attr('data-id-artiste')+'"><i class="icon-prev_round"></i></a>';
                        }

                       $('body').append(to_add);
            
                    },error:function(error){
                      console.log('Erreur');
                    }
                });

              }, // fin aftercontent
              afterClose: function(event){
                $('.lb_button').remove();
              }

        }); // FIN FEATHERLIGTH

        return false;

    });



      /******************************************/
    /******* SLIDER HOTSPOT POUR MOBILE - PAGES SERVICE *****/
    /******************************************/
       if ( $( ".HotSpot-Button" ).length ) {  

    //   $('.js-slider-interactivite').slick({
    //       arrows: true,
    //       autoplay:true,
    //       autoplaySpeed: 4000,
    //       slidesToScroll: 1,
    //       slidesToShow: 1,
    //       dots:false,
    //       pauseOnFocus:false,
    //       pauseOnHover:false,
    //       infinite:true,
    //       mobileFirst: true,
    //       responsive: [
    //       {
    //               breakpoint: 768,
    //               settings: 'unslick'
    //       }
    //     ]
    // });
     

      tippy('.HotSpot-Button', {
        content(reference) {
        const id = reference.getAttribute('data-template');
        const template = document.getElementById(id);
        return template.innerHTML;
      },
      allowHTML: true,
      interactive: true,
      maxWidth: 500,
      theme: 'wesign',
      offset: [15, 15],
      animation: 'rotate',
      moveTransition: 'transform 0.2s ease-out',
      appendTo: () => document.body,
      onTrigger(instance, event) {
        // if(l_window < 768){
        //   let id_instance = instance.id;
        //   $('.js-slider-interactivite').slick('slickGoTo', id_instance - 1);
          
        //   offsetTop = $('.InteractiveValeur').offset().top-header.height();
        //   $('html, body').stop().animate({ 
        //       scrollTop: offsetTop
        //   }, 600);

        // }
        //console.log(instance.);
      //console.log(instance.getAttribute('data-template'));
      }
    });

    } // si page entreprise 




// /***********  ******************** ********/ 
// /*********** SWIPER ARCHIVE ITEM ********/ 
// /***********  ******************** ********/ 

  $( ".ArchiveItem" ).each(function() {
 
    var id_parent = $(this).attr('id');
    
    new Swiper($(this).find('.swiper-archive-item')[0], {

        // If we need pagination
          spaceBetween: 16, // try '5%' if you want
          centeredSlides: true,
          slidesPerView: 1.35,
          loop: true,
          autoplay: {
          delay: 6000,
          disableOnInteraction: false
        },

         navigation: {
          nextEl: '#next_'+id_parent,
          prevEl: '#prev_'+id_parent
      },


      pagination: {
           el: '#'+id_parent+' .swiper-bullet-pagination',
           clickable: true
      },

        breakpoints: {
          2200: { // a partir de 769

            spaceBetween: 20,
            slidesPerView: 3.5,
            loop: true,
            centeredSlides: false,
          },

          1250: { // a partir de 769

            spaceBetween: 20,
            slidesPerView: 2.5,
            loop: true,
            centeredSlides: false,
          },
          1023: { // a partir de 769
            spaceBetween: 20,
            slidesPerView: 1.5,
            loop: true,
            centeredSlides: false,
          },
          600: { // a partir de 769
            spaceBetween: 20,
            slidesPerView: 2.5,
            loop: true,
            centeredSlides: false,
          }
        },
    }); 



  });

    

});